import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20diagonal%20collage%20of%20diverse%20fashion%20items%20including%20colorful%20sneakers%20denim%20jacket%20striped%20hoodie%20white%20tshirt%20leather%20bag%20and%20sunglasses%20arranged%20in%20a%20dynamic%20scattered%20composition%20on%20a%20soft%20warm%20ivory%20backdrop%20gentle%20morning%20light%20streaming%20from%20upper%20left%20creating%20subtle%20gradients%20editorial%20style%20high%20detail%20clean%20aesthetic%20no%20text%20no%20logos%20sophisticated%20fashion%20photography&width=1800&height=1200&seq=hero-bg-v3&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          title="Kakobuy Spreadsheet Polska 2026 – najlepszy arkusz zakupowy"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/30 via-white/20 to-white/65"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-20 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-20 max-w-7xl mx-auto">
          <div className="flex-1 w-full">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 rounded-full border-2 border-white overflow-hidden bg-background-200">
                  <img src="https://readdy.ai/api/search-image?query=Casual%20outdoor%20portrait%20of%20young%20European%20adult%20with%20relaxed%20expression%20wearing%20neutral%20toned%20hoodie%20against%20soft%20sage%20green%20natural%20background%20warm%20afternoon%20light%20editorial%20style%20high%20quality&width=80&height=80&seq=avatar-hero-01-v3&orientation=squarish" alt="" title="Zadowolony użytkownik Kakobuy Spreadsheet" className="w-full h-full object-cover" />
                </div>
                <div className="w-10 h-10 rounded-full border-2 border-white overflow-hidden bg-background-200">
                  <img src="https://readdy.ai/api/search-image?query=Natural%20light%20portrait%20of%20young%20European%20woman%20with%20genuine%20smile%20wearing%20cream%20sweater%20against%20warm%20terracotta%20colored%20wall%20soft%20bokeh%20background%20editorial%20quality%20lifestyle%20photography&width=80&height=80&seq=avatar-hero-02-v3&orientation=squarish" alt="" title="Zadowolona użytkowniczka Kakobuy Spreadsheet" className="w-full h-full object-cover" />
                </div>
                <div className="w-10 h-10 rounded-full border-2 border-white overflow-hidden bg-background-200">
                  <img src="https://readdy.ai/api/search-image?query=Urban%20street%20style%20portrait%20of%20young%20European%20man%20with%20confident%20smile%20wearing%20dark%20denim%20jacket%20against%20light%20beige%20textured%20wall%20natural%20diffused%20daylight%20editorial%20fashion%20quality&width=80&height=80&seq=avatar-hero-03-v3&orientation=squarish" alt="" title="Zadowolony użytkownik Kakobuy Spreadsheet" className="w-full h-full object-cover" />
                </div>
              </div>
              <span className="text-xs md:text-sm text-foreground-700 font-medium">
                {t("hero_social_proof")}
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-foreground-900 leading-tight">
              <span className="block">{t("hero_title_line1")}</span>
              <span className="block font-light italic text-primary-600">
                {t("hero_title_line2")}
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-sm md:text-base text-foreground-600 leading-relaxed">
              {t("hero_subtitle")}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
              >
                <span>{t("hero_cta")}</span>
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <Link
                to="/blog/kakobuy-spreadsheet-polska"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 text-sm font-medium text-foreground-700 bg-white/80 hover:bg-white rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <span>{t("btn_read_article")}</span>
                <i className="ri-article-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>

          <div className="hidden lg:flex flex-1 w-full justify-end">
            <div className="relative w-full max-w-md">
              <div className="absolute -top-6 -left-6 w-24 h-24 rounded-2xl bg-accent-100/60 -z-10"></div>
              <div className="absolute -bottom-8 -right-8 w-32 h-32 rounded-2xl bg-primary-100/50 -z-10"></div>
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-sm border border-background-200/50">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                    <i className="ri-file-list-3-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">Kakobuy Spreadsheet</p>
                    <p className="text-xs text-foreground-500">Aktualizacja: Czerwiec 2026</p>
                  </div>
                </div>
                <div className="space-y-2.5">
                  {categories.slice(0, 5).map((cat, i) => (
                    <div key={cat.id} className="flex items-center gap-2.5 text-sm">
                      <div className="w-2 h-2 rounded-full bg-accent-400 flex-shrink-0"></div>
                      <span className="text-foreground-700">{cat.name}</span>
                      <span className="text-foreground-400 text-xs ml-auto">{10 + i * 8}+ produktów</span>
                    </div>
                  ))}
                </div>
                <p className="mt-4 text-xs text-foreground-400">...i 9 więcej kategorii</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}